import React from 'react';
import { Link } from 'react-router-dom';
import { FormattedMessage } from 'react-intl';

interface Props {
  className?: string;
}

const WhatIsCrowdfunding: React.StatelessComponent<Props> = ({
  className = '',
}) => (
  <div className={className}>
    <h2 className="jg-h4">
      <Link to="/" className="jg-text--link">
        <FormattedMessage
          id="WhatIsCrowdfunding.title"
          defaultMessage="What is crowdfunding?"
        />
      </Link>
    </h2>
    <p>
      <FormattedMessage
        id="WhatIsCrowdfunding.description"
        defaultMessage="Crowdfunding is a new type of fundraising where you can raise funds for your own personal cause, even if you're not a registered charity."
      />
    </p>
    <p className="jg-text--small-light jg-space-mbn">
      <FormattedMessage
        id="WhatIsCrowdfunding.funds"
        defaultMessage="The page owner is responsible for the distribution of funds raised."
      />
    </p>
  </div>
);

export default WhatIsCrowdfunding;



// WEBPACK FOOTER //
// ./src/components/WhatIsCrowdfunding/WhatIsCrowdfunding.tsx